/* eslint-disable react/no-array-index-key */
import React from "react";
import { IconStar, IconStarFilled } from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { RATING_WIDTH } from "../../../../../../common-deprecated/styles/v2/toyota/components/Rating";
import * as Styles from "../../../../../../common-deprecated/styles/v2/toyota/components/Rating";

type RatingType = { score: number };
const Rating = ({ score }: RatingType): JSX.Element => {
    return (
        <Styles.Review>
            <Styles.StarRating>
                <Styles.Stars>
                    {new Array(5).fill(null).map((_, index) => (
                        <IconStar key={index} />
                    ))}
                </Styles.Stars>
                <Styles.StarsScore width={(score / 5) * RATING_WIDTH}>
                    <div>
                        {new Array(Math.round(score)).fill(null).map((_, index) => (
                            <IconStarFilled key={index} />
                        ))}
                    </div>
                </Styles.StarsScore>
            </Styles.StarRating>
            <Styles.Number>{score}</Styles.Number>
        </Styles.Review>
    );
};

export default Rating;
